import Loadable from '../../components/loadable';

const ContactSequences = Loadable({
  loader: () => import('../../pages/contacts/sequences'),
  type: 'block',
});

angular.module('gym').value('ContactSequences', ContactSequences);

const ContactSequence = Loadable({
  loader: () => import('../../pages/contacts/sequences/contact_sequence'),
  type: 'block',
});

angular.module('gym').value('ContactSequence', ContactSequence);

const SkipSequenceStepModal = Loadable({
  loader: () => import('../../pages/contacts/sequences/contact_sequence/skip_sequence_step_modal'),
  type: 'modal',
});

angular.module('gym').value('SkipSequenceStepModal', SkipSequenceStepModal);

const EnrolSequenceModal = Loadable({
  loader: () => import('../../pages/contacts/sequences/enrol_sequence_modal'),
  type: 'modal',
});

angular.module('gym').value('EnrolSequenceModal', EnrolSequenceModal);
